export default __webpack_public_path__ + "static/media/RockHand.d4bd57bc.png";